import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  blogList: [],
  blogDetail: [],
  loading: false,
  error: undefined,
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchBlogList(state, action) {
      state.blogList = action.payload;
      state.loading = false;
    },
    fetchBlogDetail(state, action) {
      state.blogDetail = action.payload;
      state.loading = false;
    },
  },
});

export const blogActions = blogSlice.actions;

export default blogSlice.reducer;
